<template>
  <div class="article-list-page-wrapper app-bg-white">
    <div class="app-basic-layout-wrapper">
      <ListPageTitle
        title="行业资讯"
        desc="关注行业动态，及时获取前沿洞察资讯"
      ></ListPageTitle>
      <div class="tabs-wrapper app-border-divider">
        <CategoryTabs
          v-if="tabLoaded"
          ref="categoryTabs"
          :list="tabs"
          :current="current"
          @tab-change="tabChange"
        ></CategoryTabs>
      </div>
      <BaseEmpty v-if="empty"></BaseEmpty>
      <div
        v-infinite-scroll="loadMore"
        class="list-wrapper"
        infinite-scroll-disabled="busy"
        infinite-scroll-listen-for-event="load-first-screen"
      >
        <keep-alive>
          <component :is="view" :list="list" link-target="_blank"></component>
        </keep-alive>
        <BaseLoading v-show="loading"></BaseLoading>
      </div>
    </div>
  </div>
</template>

<script>
import ListPageTitle from '@/components/listPageTitle/ListPageTitle'
import CategoryTabs from '@/components/categoryTabs/CategoryTabs'
import ArticleList from '@/components/article/ArticleList'
import TopicList from '@/components/topic/TopicList'

import { listCanLoadMore } from '@/utils'
import { constants } from '@/global'
import { THIRD_API } from '@/global/config'

// pz
const { DEFAULT_PZ } = constants
// 专题tab配置
const TOPIC_TAB_INFO = { id: 'topic', name: '营销专题', sort: 0 }
// 推荐tab配置
const RECOMMEND_TAB_INFO = { id: 0, name: '推荐', sort: 0 }

const articleMetaInfo = {
  title: '行业资讯-微博营销官网',
  meta: [
    {
      name: 'description',
      vmid: 'description',
      content:
        '为您提供新鲜的行业数据报告下载，白皮书、微博财报等。行业活动报名，掌握市场营销动向，引领行业风向标'
    },
    {
      name: 'keywords',
      vmid: 'keywords',
      content:
        '互联网资讯,营销资讯,数据报告,白皮书,市场活动,行业报告,营销风向标,微博资讯,social动态'
    }
  ]
}

const topicMetaInfo = {
  title: '推广专题-微博营销官网',
  meta: [
    {
      name: 'description',
      vmid: 'description',
      content:
        '为您提供新鲜的行业数据报告下载，白皮书、微博财报等。行业活动报名，掌握市场营销动向，引领行业风向标'
    },
    {
      name: 'keywords',
      vmid: 'keywords',
      content:
        '互联网资讯,营销资讯,数据报告,白皮书,市场活动,行业报告,营销风向标,微博资讯,social动态'
    }
  ]
}

export default {
  metaInfo: articleMetaInfo,
  components: {
    ListPageTitle,
    CategoryTabs,
    ArticleList,
    TopicList
  },
  data() {
    return {
      tabs: [],
      loading: false,
      empty: false,
      // tab加载完
      tabLoaded: false,
      current: 0, // 当前tab的索引
      pg: null,
      pz: DEFAULT_PZ,
      type: null, // 当前tab的id，type===topic：专题列表
      params: {},
      list: [],
      busy: false
    }
  },
  computed: {
    view() {
      return this.type === 'topic' ? 'topic-list' : 'article-list'
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      await this.getTabs()
      const { type } = this.$route.query
      this.type = type || this.tabs[0].id
      for (let i = 0; i < this.tabs.length; i++) {
        if (this.type === this.tabs[i].id) {
          this.current = i
          break
        }
      }
      this.tabLoaded = true
      this.$emit('load-first-screen')
      const { set } = this.$meta().addApp('')
      if (this.type === TOPIC_TAB_INFO.id) {
        set(topicMetaInfo)
      }
    },
    async getTabs() {
      const { data = [] } = await this.$http.get(
        THIRD_API.alkArticleCategoryList.link
      )
      this.tabs = [RECOMMEND_TAB_INFO, ...data, TOPIC_TAB_INFO]
    },
    async getList() {
      let params = {
        pg: this.pg,
        pz: this.pz
      }
      // 是否是专题页
      const isTopicList = this.type === 'topic'
      if (!isTopicList) {
        params = { ...params, type: this.type }
      }
      // 避免多次触发
      if (this.busy || this.loading) return
      this.busy = true
      this.loading = true
      this.empty = false
      try {
        const {
          total,
          pg,
          pz,
          data = []
        } = isTopicList
          ? await this.$http.get(THIRD_API.alkTopicList.link, { params }, true)
          : await this.$http.get(
              THIRD_API.alkArticleList.link,
              { params },
              true
            )
        this.loading = false
        this.empty = parseInt(total) <= 0
        this.list = [...this.list, ...data]
        this.pz = pz
        this.pg = pg
        this.busy = !listCanLoadMore({ pz, pg, total })
      } catch {
        this.busy = true
        this.loading = false
      }
    },
    loadMore() {
      if (this.tabLoaded) {
        // 绑定后会立即触发一次，处理初次pg = 1
        this.pg = this.pg ? ++this.pg : 1
        this.getList()
      }
    },
    resetList() {
      this.pg = 1
      this.list = []
      this.busy = false
      this.loading = false
      this.getList()
    },
    tabChange(item, index) {
      this.current = index
      this.type = item.id
      this.resetList()
      const { set } = this.$meta().addApp('')
      if (item.id === TOPIC_TAB_INFO.id) {
        set(topicMetaInfo)
      } else {
        set(articleMetaInfo)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.article-list-page-wrapper {
  padding: 67px 0 88px;
  .tabs-wrapper {
    margin: 32px 0;
    padding-bottom: 13px;
  }
}
</style>
